import { z } from 'zod';
import { memberIdSchema } from '../identity/legacy-identity-id';

// Strict pointer-shaped payload for `member.diagnosis.recorded` (ADR-052): the
// new `member_diagnoses` row id and its member. Kind, severity and label stay on
// the row; `.strict()` turns a leak of any of them into a parse failure.
export const memberDiagnosisRecordedPayloadSchema = z
  .object({
    memberDiagnosisId: z.string().uuid(),
    memberId: memberIdSchema,
  })
  .strict();
export type MemberDiagnosisRecordedPayload = z.infer<typeof memberDiagnosisRecordedPayloadSchema>;
